import {JsonConverter} from '../JsonConverter'
import { Decision } from 'app/dominio/decision'

export class Conclusion implements JsonConverter{

  private _texto: string
  private _decisiones: Decision[]
  private _razones: string[]

  constructor (texto: string, decisiones: Decision[], razones: string[]) {
    this._texto = texto 
    this._decisiones = decisiones 
    this._razones = razones 
  }

  get texto(): string {
    return this._texto
  }

  get decisiones(): Decision[] {
    return this._decisiones
  }

  get razones(): string[] {
    return this._razones
  }

  toJson() {
    return {
      texto: this.texto,
      decisiones: this.decisiones.map( d => d.toJson()),
      razones: this.razones
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/conclusion.ts